(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from '@nextcloud/axios';
import { generateOcsUrl, generateUrl } from '@nextcloud/router';
import { showSuccess, showWarning, showError } from '@nextcloud/dialogs';
import '@nextcloud/dialogs/styles/toast';
import { api } from './Common/Api';
import './filelist.scss';
var mimeTypes = ['application/pdf', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.graphics', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.ms-powerpoint', 'application/vnd.ms-excel', 'image/jpeg', 'image/png', 'text/plain', 'text/rtf'];

function createDirectShare(fileId) {
  var _a, _b, _c;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var url, createResponse;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = generateOcsUrl('apps/dav/api/v1/', undefined, {
              ocsVersion: 1,
              escape: true,
              noRewrite: true
            }) + 'direct';
            _context.next = 3;
            return axios.post(url, {
              fileId: fileId
            });

          case 3:
            createResponse = _context.sent;
            return _context.abrupt("return", (_c = (_b = (_a = createResponse.data) === null || _a === void 0 ? void 0 : _a.ocs) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.url);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function createRoomWithFile(shareUrl, filename, roomUid) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var joinUrl;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            joinUrl = generateUrl('/apps/bbb/b/{uid}?u={url}&filename={filename}', {
              uid: roomUid,
              url: shareUrl,
              filename: filename
            });
            window.open(joinUrl, '_blank', 'noopener,noreferrer');

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

function insertDocumentToRoom(shareUrl, filename, roomUid) {
  return api.insertDocument(roomUid, shareUrl, filename);
}

function sendFile(fileId, filename, roomUid) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var shareUrl, isRunning, success;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return createDirectShare(fileId);

          case 2:
            shareUrl = _context3.sent;
            _context3.next = 5;
            return api.isRunning(roomUid);

          case 5:
            isRunning = _context3.sent;

            if (!isRunning) {
              _context3.next = 19;
              break;
            }

            _context3.prev = 7;
            _context3.next = 10;
            return insertDocumentToRoom(shareUrl, filename, roomUid);

          case 10:
            success = _context3.sent;

            if (success) {
              showSuccess(t('bbb', 'The file "{filename}" was uploaded to your room.', {
                filename: filename
              }));
            } else {
              showWarning(t('bbb', 'The file "{filename}" could not be uploaded to your room.', {
                filename: filename
              }));
            }

            _context3.next = 17;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](7);
            showError(t('bbb', 'The file "{filename}" could not be uploaded to your room. Maybe your BigBlueButton server does not support this action.', {
              filename: filename
            }));

          case 17:
            _context3.next = 20;
            break;

          case 19:
            createRoomWithFile(shareUrl, filename, roomUid);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[7, 14]]);
  }));
}

function openDialog(fileId, filename) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var initContent, title, rooms, container, table, _iterator, _step, _loop, description;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            initContent = '<div id="bbb-file-action"><span className="icon icon-loading-small icon-visible"></span></div>';
            title = t('bbb', 'Send file to BBB');
            _context4.next = 4;
            return OC.dialogs.message(initContent, title, 'none', -1, undefined, true, true);

          case 4:
            _context4.next = 6;
            return api.getRooms();

          case 6:
            rooms = _context4.sent;
            container = $('#bbb-file-action').empty();
            table = $('<table>').appendTo(container);
            table.attr('style', 'margin-top: 1em; width: 100%;');
            _iterator = _createForOfIteratorHelper(rooms);

            try {
              _loop = function _loop() {
                var room = _step.value;
                var row = $('<tr>');
                var button = $('<button>');

                if (!OC.debug) {
                  button.prop('disabled', room.running);
                }

                button.text(room.running ? t('bbb', 'Send to') : t('bbb', 'Start with'));
                button.addClass(room.running ? 'success' : 'primary');
                button.attr('type', 'button');
                button.on('click', function (ev) {
                  ev.preventDefault();
                  table.find('button').prop('disabled', true);
                  $(ev.target).addClass('icon-loading-small');
                  sendFile(fileId, filename, room.uid).then(function () {
                    container.parents('.oc-dialog').find('.oc-dialog-close').trigger('click');
                  });
                });
                row.append($('<td>').append(button));
                row.append($('<td>').attr('style', 'width: 100%;').text(room.name));
                row.appendTo(table);
              };

              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (rooms.length > 0) {
              description = t('bbb', 'Please select the room in which you like to use the file "{filename}".', {
                filename: filename
              });
              container.append(description);
              container.append(table);
            } else {
              container.append($('p').text(t('bbb', 'No rooms available!')));
            }

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

function registerFileAction(fileActions, mime) {
  fileActions.registerAction({
    name: 'bbb',
    displayName: t('bbb', 'Send to BBB'),
    mime: mime,
    permissions: OC.PERMISSION_SHARE,
    icon: OC.imagePath('bbb', 'app-dark.svg'),
    actionHandler: function actionHandler(fileName, context) {
      console.log('Action handler');
      openDialog(context.fileInfoModel.id, fileName);
    }
  });
}

var BBBFileListPlugin = {
  ignoreLists: ['trashbin'],
  attach: function attach(fileList) {
    if (this.ignoreLists.includes(fileList.id) || !OC.currentUser) {
      return;
    }

    mimeTypes.forEach(function (mime) {
      return registerFileAction(fileList.fileActions, mime);
    });
  }
};
OC.Plugins.register('OCA.Files.FileList', BBBFileListPlugin);
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(__awaiter, "__awaiter", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(mimeTypes, "mimeTypes", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(createDirectShare, "createDirectShare", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(createRoomWithFile, "createRoomWithFile", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(insertDocumentToRoom, "insertDocumentToRoom", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(sendFile, "sendFile", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(openDialog, "openDialog", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(registerFileAction, "registerFileAction", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
  reactHotLoader.register(BBBFileListPlugin, "BBBFileListPlugin", "/home/klaus/Repos/cloud_bbb/ts/filelist.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();